import { Box, Typography, Container, IconButton } from "@mui/material";
import FacilityVideoPopup from "../../components/FacilityVideoPopup";
import EngineeringIcon from "@mui/icons-material/Engineering";
import InventoryIcon from "@mui/icons-material/Inventory";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";

const brandBlue = "#1a237e";
const brandRed = "#d50000";

export default function OurStrengths() {

  const strengths = [
    {
      label: "Advanced Machinery",
      icon: <PrecisionManufacturingIcon fontSize="large" />,
    },
    { label: "Skilled Workforce", icon: <EngineeringIcon fontSize="large" /> },
    {
      label: "Reliable Supply Chain",
      icon: <InventoryIcon fontSize="large" />,
    },
    { label: "Timely Delivery", icon: <AccessTimeIcon fontSize="large" /> },
    {
      label: "Strict Quality Control",
      icon: <CheckCircleIcon fontSize="large" />,
    },
    { label: "Custom Engineering", icon: <EngineeringIcon fontSize="large" /> },
  ];

  return (
    <Box
      sx={{
        py: 10,
        background: "linear-gradient(135deg, #1a237e15, #d5000015)",
        // background: "linear-gradient(135deg, #0d0f19, #111627, #0b0e18)",
        // background:
        //   "linear-gradient(135deg, rgba(26,35,126,0.8), rgba(213,0,0,0.8))",
      }}
    >
      <Container maxWidth="lg">
        {/* Title */}
        <Typography
          variant="h4"
          fontWeight={800}
          sx={{
            mb: 1,
            color: brandBlue,
            fontSize: { xs: "1.8rem", md: "2.3rem" },
            textAlign: "center",
          }}
        >
          Our Strengths
        </Typography>
        {/* <Typography
          variant="h4"
          fontWeight={800}
          sx={{ mb: 6, textAlign: "center", color: "#1a237e" }}
        >
          Our Strengths
        </Typography> */}

        <Box
          sx={{
            width: 80,
            height: 4,
            background: brandRed,
            borderRadius: 2,
            mx: "auto",
            mb: 6,
          }}
        />

        {/* Strengths Grid */}
        <Box
          sx={{
            display: "grid",
            gap: 3,
            gridTemplateColumns: {
              xs: "1fr",
              sm: "1fr 1fr",
              md: "1fr 1fr 1fr",
            },
          }}
        >
          {strengths.map((item, i) => (
            <Box
              key={i}
              sx={{
                p: 4,
                borderRadius: 4,
                textAlign: "center",
                backdropFilter: "blur(10px)",
                background: "rgba(255,255,255,0.35)",
                boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
                transition: "0.35s",
                border: "1px solid rgba(255,255,255,0.4)",
                animation: `fadeIn .6s ease ${i * 0.15}s`,
                "@keyframes fadeIn": {
                  from: { opacity: 0, transform: "translateY(20px)" },
                  to: { opacity: 1, transform: "translateY(0px)" },
                },
                "&:hover": {
                  transform: "translateY(-10px)",
                  boxShadow: "0 12px 35px rgba(0,0,0,0.25)",
                },
              }}
            >
              <Box sx={{ color: "#1a237e", mb: 2 }}>{item.icon}</Box>
              <Typography fontWeight={700}>{item.label}</Typography>
            </Box>
          ))}
        </Box>

        {/* Video Section */}
        {/* <Box sx={{ textAlign: "center", mt: 6 }}>
          <FacilityVideoPopup
            thumbnail="https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg"
            videoUrl="https://www.youtube.com/embed/dQw4w9WgXcQ"
            buttonLabel="Watch Our Facility Tour"
          />
        </Box> */}
      </Container>
    </Box>
  );
}
